/**
 * Calculates the cumulative scroll position of an element relative to a parent element.
 *
 * @param {HTMLElement} element - The element to calculate the scroll position for.
 * @param {HTMLElement} parent - The parent element to calculate the scroll position relative to.
 * @returns {Object} - An object with 'left' and 'top' properties representing the x and y scroll
 * positions respectively.
 */

const getCumulativeScrollOffsets = (element, parent) => {
  let left = 0;
  let top = 0;
  let workingElement = element;

  do {
    left += workingElement.scrollLeft || 0;
    top += workingElement.scrollTop || 0;
    workingElement = workingElement.parentNode;
  } while (workingElement && workingElement !== parent);

  if (workingElement === parent) {
    left += workingElement.scrollLeft;
    top += workingElement.scrollTop;
  }

  return {
    left,
    top,
  };
};

export { getCumulativeScrollOffsets };
